// @ts-nocheck
import { withInstall, type SFCWithInstall } from '@ll-plus/utils'

import KeyValue from './src/key-value.vue'

export const LlKeyValue: SFCWithInstall<typeof KeyValue> = withInstall(KeyValue)

export default LlKeyValue

export * from './src/config'

declare module 'vue' {
  export interface GlobalComponents {
    LlKeyValue: typeof KeyValue
  }
}
